import { useEffect } from "react";
import { startIkTargetFollower } from "../../ik/ikTarget/follower";

export function useIkTargetFollower() {
  useEffect(() => {
    const stop = startIkTargetFollower();
    return () => {
      if (typeof stop === "function") stop();
    };
  }, []);
}
